// extracted by mini-css-extract-plugin
export default {"recos":"L7-z","productCardOverride":"M7-z","rowHasBadge":"N7-z"};